import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';
import FJConfig from '../../config/FJConfig';
import FJAppConstant from '../../constants/FJAppConstant';
export const FJSliceImageManipulation = createSlice({
    name: 'imageManipulation',
    initialState: {
        uploadImageInfo: {},
        switchOldPhotoRestoration: FJConfig.appType !== FJAppConstant.PHOTO_COLORIZE,
        switchPhotoColorize: FJConfig.appType === FJAppConstant.PHOTO_COLORIZE,
        imageEnhancerData: {
            switch: false,
            imageType: FJConstant.FACE,
            upscale: 2,
        },

        switchScratchOrFold: false,
        downloadEditImageLoading: false,

        useNumFunctionData: {
            oldPhotoRestoration: 0,
            photoColorize: 0,
            imageEnhancer: 0,
            scratchOrFold: 0,
        },

        scratchRepairMaskUrl: null,
    },
    reducers: {
        setSliceUploadImageInfoAction: (state, action) => {
            state.uploadImageInfo = action.payload;
        },
        setSliceSwitchOldPhotoRestorationAction: (state, action) => {
            state.switchOldPhotoRestoration = action.payload;
        },
        setSliceSwitchPhotoColorizeAction: (state, action) => {
            state.switchPhotoColorize = action.payload;
        },
        setSliceImageEnhancerDataAction: (state, action) => {
            state.imageEnhancerData = action.payload;
        },
        setSliceSwitchScratchOrFold: (state, action) => {
            state.switchScratchOrFold = action.payload;
        },
        setSliceDownloadEditImageLoading: (state, action) => {
            state.downloadEditImageLoading = action.payload;
        },
        setSliceUseNumFunctionData: (state, action) => {
            state.useNumFunctionData = action.payload;
        },
        setSliceScratchRepairMaskUrl: (state, action) => {
            state.scratchRepairMaskUrl = action.payload;
        },
    },
});

export const {
    setSliceUploadImageInfoAction,
    setSliceSwitchOldPhotoRestorationAction,
    setSliceSwitchPhotoColorizeAction,
    setSliceImageEnhancerDataAction,
    setSliceSwitchScratchOrFold,
    setSliceDownloadEditImageLoading,
    setSliceUseNumFunctionData,
    setSliceScratchRepairMaskUrl,
} = FJSliceImageManipulation.actions;

export default FJSliceImageManipulation.reducer;
